import { WhiteSpace } from "@aeo/core/components";
import fields from "@aeo/core/fields";
import { useScrollTo } from "@aeo/core/hooks";
import messages from "@aeo/core/messages";
import { capitalize } from "@aeo/core/utils";
import { KeyValueCard, NotesCardForm } from "../components";

export const SecurityThreeValues = () => {
  const securityThree = fields.securityThree;

  //If id of mention exists in url scroll to it.
  useScrollTo();

  return (
    <>
      <h4>{capitalize(messages.titles.enteredGoods)}</h4>
      <WhiteSpace />
      <KeyValueCard {...securityThree.security_goods_procedure} />
      <KeyValueCard {...securityThree.checking_security_procedure} />
      <KeyValueCard {...securityThree.employee_security_measures} />
      <KeyValueCard {...securityThree.checking_goods_seals} />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.has_import_goods_sealed} type="boolean" />
      <KeyValueCard {...securityThree.has_types_of_goods} type="boolean" />
      <KeyValueCard {...securityThree.import_goods_sealed} NA />
      <KeyValueCard {...securityThree.has_marking_goods} type="boolean" />
      <KeyValueCard {...securityThree.marking_goods} type="boolean" />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.counting_process} />
      <KeyValueCard {...securityThree.counting_process_register} />
      <KeyValueCard
        {...securityThree.has_separated_responsible}
        type="boolean"
      />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.has_internal_control} type="boolean" />
      <KeyValueCard {...securityThree.internal_control} NA />
      <WhiteSpace />
      <h4>{capitalize(messages.titles.goodsStorage)}</h4>
      <WhiteSpace />
      <KeyValueCard {...securityThree.allocated_storage_subdivision} />
      <KeyValueCard {...securityThree.assigning_storage_procedure} />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.has_outdoor_storage} type="boolean" />
      <KeyValueCard {...securityThree.outdoor_storage} NA />
      <WhiteSpace v="1rem" />
      <KeyValueCard
        {...securityThree.has_inventorying_procedures}
        type="boolean"
      />
      <KeyValueCard {...securityThree.inventorying_procedures} NA />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.has_stored_separate} type="boolean" />
      <KeyValueCard {...securityThree.criteria_separate_storage} />
      <KeyValueCard {...securityThree.register_accounting_goods} />
      <KeyValueCard {...securityThree.protected_goods_access} />
      <KeyValueCard {...securityThree.procedures_verified} />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.has_third_party_storage} type="boolean" />
      <KeyValueCard {...securityThree.third_party_storage} NA />
      <WhiteSpace />
      <h4>{capitalize(messages.titles.goodsProduction)}</h4>
      <WhiteSpace />
      <KeyValueCard {...securityThree.production_subdivisions} />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.has_external_production} type="boolean" />
      <KeyValueCard {...securityThree.external_production} NA />
      <WhiteSpace v="1rem" />
      <KeyValueCard
        {...securityThree.has_protect_access_measures}
        type="boolean"
      />
      <KeyValueCard {...securityThree.protect_access_measures} NA />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.product_packaging_procedure} />
      <WhiteSpace v="1rem" />
      <KeyValueCard
        {...securityThree.has_third_party_packaging}
        type="boolean"
      />
      <KeyValueCard {...securityThree.third_party_packaging} NA />
      <WhiteSpace v="1rem" />
      <h4>{capitalize(messages.titles.goodsLoading)}</h4>
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.goods_loading} />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.has_loading_procedure} type="boolean" />
      <KeyValueCard {...securityThree.has_goods_sealed} type="boolean" />
      <KeyValueCard {...securityThree.goods_sealed} NA />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.has_seals_register} type="boolean" />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.seals_register} />
      <KeyValueCard {...securityThree.client_requirements} />
      <KeyValueCard {...securityThree.supervision_measures} />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.has_checking_completion} type="boolean" />
      <KeyValueCard {...securityThree.checking_completion} NA />
      <WhiteSpace v="1rem" />
      <KeyValueCard {...securityThree.checking_coming_orders} />
      <KeyValueCard {...securityThree.loading_procedure} />
      <WhiteSpace />
      <h4>{capitalize(messages.titles.requiredDocuments)}</h4>
      <WhiteSpace />
      <KeyValueCard {...securityThree.attachments} type="attachments" />
    </>
  );
};

export const SecurityThree = () => {
  return (
    <NotesCardForm
      title={messages.SAQTabs.security.title}
      content={<SecurityThreeValues />}
      path="saq/security_three"
    />
  );
};
